import { Suspense } from 'react';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { PcmpMarketingBatchPage } from '@/features/pcmp/pages/PcmpMarketingBatchPage';
import { pcmpMarketingBatchSearchSchema } from '@/features/pcmp/types/pcmpMarketing.types';

export const Route = createFileRoute('/_auth/pcmp/marketing/batches/$batchNo/')({
  parseParams: ({ batchNo }) => {
    const parsedNo = Number(batchNo);
    if (!Number.isInteger(parsedNo) || parsedNo <= 0) throw notFound();
    return { batchNo: parsedNo };
  },
  validateSearch: pcmpMarketingBatchSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="PCMP Marketing Batch">
      <Suspense fallback={<PageLoader />}>
        <PcmpMarketingBatchPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
